import React from 'react';
const stats = [{
  value: '20+',
  label: 'Países hispanohablantes donde ya se usa el sistema',
  pending: true
}, {
  value: '6 + 5',
  label: 'Tomos operativos y herramientas de campo',
  pending: false
}, {
  value: '4.9/5',
  label: 'Valoración promedio',
  pending: true
}, {
  value: 'De punta a punta',
  label: 'Del primer «Hola, ¿precio para boda?» a la recomendación final',
  pending: false
}];
export function SocialProofBar() {
  return <section aria-label="Prueba social" className="w-full bg-ink text-ivory" data-id="element-219" data-mp="32h0hwbcvn63y">
      <div className="mx-auto max-w-6xl px-5 py-10" data-id="element-220" data-mp="2xkjium4537c3">
        <div className="grid grid-cols-2 gap-y-8 sm:grid-cols-4 sm:divide-x sm:divide-gold/25" data-id="element-221" data-mp="2thwzzapg4wr1">
          {stats.map(stat => <div key={stat.label} className="px-4 text-center" data-id="element-222" data-mp="2oik0nqhe1x7k">
              <div className="font-serif text-2xl sm:text-3xl text-gold" data-id="element-223" data-mp="1i2zu6p51lswz">
                {stat.value}
                {stat.pending && <span className="align-super text-xs text-gold/60" aria-hidden="true" data-id="element-224" data-mp="1d2lnbaf6gp0j">
                    †
                  </span>}
              </div>
              <div className="mt-2 text-[11px] uppercase tracking-[0.16em] text-ivory/60" data-id="element-225" data-mp="1dnntb7nitu6i">
                {stat.label}
              </div>
            </div>)}
        </div>
        <p className="mt-8 text-center text-[10px] uppercase tracking-[0.18em] text-ivory/35" data-id="element-226" data-mp="14mh8wnhr3z7z">
          † Métricas pendientes de verificación antes de publicar
        </p>
      </div>
    </section>;
}